import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import "./SubscribePage.css";

const PaymentPage = () => {
  const [selectedPlan, setSelectedPlan] = useState("");
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const navigate = useNavigate(); // Initialize useNavigate for navigation

  const plans = [
    {
      name: "Trial",
      price: "Free",
      details: [
        "Online assessment on sustainable packaging design",
        "Up to 5 assessments per user",
        "Email support",
      ],
      buttonText: "Get started",
    },
    {
      name: "Started",
      price: "USD 19/assessment",
      details: [
        "Online assessment on sustainable packaging design",
        "Up to 5 assessments per user",
        "View recommendations",
        "Save product portfolio",
        "Email support",
      ],
      buttonText: "Pay now",
      amount: 19,
    },
    {
      name: "Basic",
      price: "USD 49/assessment",
      details: [
        "Online assessment on sustainable packaging design",
        "Online assessment on country legislative",
        "View recommendations",
        "Save product portfolio",
        "Email support",
      ],
      buttonText: "Pay now",
      amount: 49,
    },
    {
      name: "Plus",
      price: "USD 100/assessment",
      details: [
        "Online assessment on sustainable packaging design",
        "Online assessment on country legislative",
        "View/download/share recommendations",
        "Unlimited product portfolio storage",
        "Edit/duplicate product portfolio",
        "Consultation up to 45 mins",
        "Discount for multiple use",
        "Priority email support",
      ],
      buttonText: "Pay now",
      amount: 100,
    },
  ];

  // Fetch customer data from the API
  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await fetch("https://backend.rethinkpack.com/api/allCustomers");
        const data = await response.json();
        const customer = data?.[0]; // Assuming you want the first customer from the response
        if (customer) {
          setProfileData({
            name: customer.name,
            email: customer.email,
            phone: customer.phone,
            address: customer.address,
          });
        }
      } catch (error) {
        console.error("Error fetching customer data:", error.message);
      }
    };

    fetchCustomerData();
  }, []);

  const handlePayment = async (plan) => {
    if (plan.name === "Trial") {
      // Redirect to customer-dashboard for the Trial plan
      navigate("/customer-dashboard");
      return;
    }

    if (!window.Razorpay) {
      alert("Razorpay SDK not loaded. Please try again.");
      return;
    }

    setLoading(true);
    setSelectedPlan(plan.name);

    try {
      const response = await axios.post("https://rethinkpack.com/create-order", {
        amount: plan.amount , // Amount in cents
        currency: "USD",
      });

      const { id: order_id, currency } = response.data;

      const options = {
        key: "rzp_test_DPEw3iw0jtBhQP", // Replace with your Razorpay Key ID
        amount: plan.amount * 100,
        currency,
        name: "RETHINKPACK",
        description: `${plan.name} Plan Subscription`,
        order_id,
        handler: function (response) {
          alert(
            `Payment successful for ${plan.name} plan! Payment ID: ${response.razorpay_payment_id}`
          );
        },
        prefill: {
          name: profileData.name || "Your Name",
          email: profileData.email || "your.email@example.com",
          contact: profileData.phone || "9999999999",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment failed:", error.message);
      alert("Failed to initiate payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscribe-container">
      <h1 className="subscribe-heading">Choose Your Subscription Plan</h1>
      <div className="plans-container">
        {plans.map((plan, index) => (
          <div className="plan" key={index}>
            <h3>{plan.name}</h3>
            <p className="price">{plan.price}</p>
            <ul>
              {plan.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
            <button
              className="btn"
              onClick={() => handlePayment(plan)}
              disabled={loading && selectedPlan === plan.name}
            >
              {loading && selectedPlan === plan.name ? "Processing..." : plan.buttonText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentPage;
